module.exports = __webpack_public_path__ + "static/media/8_ihmisarvoista-tyota-ja-talouskasvua_en_US.00a9b839.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/8_ihmisarvoista-tyota-ja-talouskasvua_en_US.svg
// module id = ./src/images/agendaIcons/8_ihmisarvoista-tyota-ja-talouskasvua_en_US.svg
// module chunks = 1